import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ0NjA5Mzg3MDg1IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEyMTUyIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTQ0OCAxMjhhMzIwIDMyMCAwIDAgMSAyNDcuNzQ0IDUyMi40OTZsMTkwLjkxMiAxOTAuODQ4YTMyIDMyIDAgMCAxLTQwLjgzMiA0OC45NmwtNC40OC0zLjY0OC0xOTAuODQ4LTE5MC45MTJBMzIwIDMyMCAwIDEgMSA0NDggMTI4eiBtMCA2NGEyNTYgMjU2IDAgMSAwIDAgNTEyIDI1NiAyNTYgMCAwIDAgMC01MTJ6IiBwLWlkPSIxMjE1MyI+PC9wYXRoPjwvc3ZnPg==)
 */
export const SearchIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M448 128a320 320 0 0 1 247.744 522.496l190.912 190.848a32 32 0 0 1-40.832 48.96l-4.48-3.648-190.848-190.912A320 320 0 1 1 448 128z m0 64a256 256 0 1 0 0 512 256 256 0 0 0 0-512z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
